<template>
  <Start>
    <transition name="fade" mode="out-in">
      <Login
        v-if="action === 'signin'"
        :email="email"
        @action="handleAction($event)"
        @complete="twoFa = $event"
      ></Login>
      <PasswordSend
        v-if="action === 'reset'"
        @action="handleAction($event)"
      ></PasswordSend>
      <TwoFa
        v-if="action === 'twoFa'"
        v-model="showSignup"
        :data="twoFa"
        @failed="email = $event"
        @action="handleAction($event)"
        @hide="handleAction('')"
      ></TwoFa>
    </transition>

    <Signup
      v-if="action === 'signup'"
      v-model="showSignup"
      @complete="email = $event.mail"
      @hide="handleAction('signin')"
    ></Signup>
  </Start>
</template>

<style scoped>
.logo {
  display: flex;
  justify-content: center;
  margin-top: 1em;
  margin-bottom: 1em;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>

<script>
import Start from "@/components/singles/Start.vue";

export default {
  components: {
    Login: () => import("@/components/main/user/Login.vue"),
    PasswordSend: () => import("@/components/main/user/PasswordSend.vue"),
    Signup: () => import("@/components/main/user/Signup.vue"),
    TwoFa: () => import("@/components/main/user/2Fa.vue"),
    Start,
  },
  data() {
    return {
      action: "signin",
      showSignup: false,
      email: "",
      twoFa: null,
    };
  },
  methods: {
    handleAction(action) {
      if (action === "signup") this.showSignup = true;

      this.action = action;
    },
  },
};
</script>
